module.exports = __webpack_public_path__ + "img/import.15d3a8ce.svg";